module.exports = __webpack_public_path__ + "img/2a.d65ff055.jpg";